import React, { HTMLAttributes } from 'react';
import { InputNumber } from '@meitu/saas-ui';
import LabelAction from '@/components/label-action';
import { useEditor } from '@/hooks/use-editor';
import { useLocaleStore } from '@/i18n';

interface IProps extends HTMLAttributes<HTMLDivElement> {
    id: string;
    left: number;
    top: number;
    lock: boolean;
    onPosition?: () => void;
}
const PositionInspector: React.FC<IProps> = ({ id, left, top, lock, onPosition }) => {
    const { $t } = useLocaleStore();
    const editor = useEditor();

    const handlePosition = (key: 'left' | 'top', val: number | null, options?: { writeHistory: boolean }) => {
        if (val === null) return;
        editor.layer.modifyBasicProperties.position(id, { [key]: val }, options);
    };

    return (
        <div className="c-base-toolbar-controller">
            <LabelAction title={$t((v) => v.baseToolbar.position)} align>
                <InputNumber
                    style={{ marginRight: 4 }}
                    value={left}
                    showStepBtn={false}
                    disabled={lock}
                    onChange={(val: number | null) => {
                        handlePosition('left', val, { writeHistory: false });
                    }}
                    onChangeAfter={(val: number | null) => {
                        handlePosition('left', val, { writeHistory: true });
                        onPosition?.();
                    }}
                    suffix={<span>X</span>}
                />
                <InputNumber
                    value={top}
                    showStepBtn={false}
                    disabled={lock}
                    onChange={(val: number | null) => {
                        handlePosition('top', val, { writeHistory: false });
                    }}
                    onChangeAfter={(val: number | null) => {
                        handlePosition('top', val, { writeHistory: true });
                        onPosition?.();
                    }}
                    suffix={<span>Y</span>}
                />
            </LabelAction>
        </div>
    );
};

export default React.memo(PositionInspector);
